import { FileText } from "lucide-react";

export default function BetslipIcon({ count = 0 }) {
  return (
    <div className="relative w-6 h-6 flex items-center justify-center">
      {count > 0 ? (
        // Show count number when greater than 1
        <span className="bg-yellow text-bluedarkmode text-lg font-bold rounded-full w-8 h-8 flex items-center justify-center">
          {count}
        </span>
      ) : (
        // Show receipt icon when count is 0 or 1
        <>
          <FileText size={20} color="darkblue" className="w-6 h-6" />
          {/* {count === 1 && (
            <span className="absolute -top-1 -right-1 bg-yellow text-bluedarkmode text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
              1
            </span>
          )} */}
        </>
      )}
    </div>
  );
}
